// extracted by mini-css-extract-plugin
export default {"descriptionToggleButton":"A9-z"};